import request from "@/utils/request";

// 获取用户主页
export function getIndex(data) {
  return request({
    method: "post",
    path: "user/index",
    data,
  });
}

// 获取账户设置
export function getInfo(data) {
  return request({
    method: "post",
    path: "user/getInfo",
    data,
  });
}

// 保存账户设置
export function setInfo(data) {
  return request({
    method: "post",
    path: "user/setInfo",
    data,
  });
}

// 获取身份认证
export function getIdentity(data) {
  return request({
    method: "post",
    path: "user/getIdentity",
    data,
  });
}

// 身份认证保存
export function setIdentity(data) {
  return request({
    method: "post",
    path: "user/setIdentity",
    data,
  });
}

// 修改密码
export function setPassword(data) {
  return request({
    method: "post",
    path: "user/setPassword",
    data,
  });
}

// 修改支付密码
export function setPayPassword(data) {
  return request({
    method: "post",
    path: "user/setPayPassword",
    data,
  });
}

// 修改支付密码
export function setPhone(data) {
  return request({
    method: "post",
    path: "user/setPhone",
    data,
  });
}

// 检测供应商
export function checkSupplier(data) {
  return request({
    method: "post",
    path: "user/checkSupplier",
    data,
  });
}

// 获取余额列表
export function getBalanceList(data) {
  return request({
    method: "post",
    path: "user/getBalanceList",
    data,
  });
}

// 获取积分列表
export function getIntegralList(data) {
  return request({
    method: "post",
    path: "user/getIntegralList",
    data,
  });
}

// 获取信用金列表
export function getCreditDepositList(data) {
  return request({
    method: "post",
    path: "user/getCreditDepositList",
    data,
  });
}

// 获取优惠券列表
export function getCouponList(data) {
  return request({
    method: "post",
    path: "user/getCouponList",
    data,
  });
}

//获取团队详情
export function getTeamIndex(data) {
  return request({
    method: "post",
    path: "user/getTeamIndex",
    data,
  });
}

// 申请加入团队
export function applyTeam(data) {
  return request({
    method: "post",
    path: "user/applyTeam",
    data,
  });
}

// 获取团队列表
export function getAllTeamList(data) {
  return request({
    method: "post",
    path: "user/getAllTeamList",
    data,
  });
}

// 申请创建团队
export function addTeam(data) {
  return request({
    method: "post",
    path: "user/addTeam",
    data,
  });
}

// 申请身份认证
export function userIdentity(data) {
  return request({
    method: "post",
    path: "user/userIdentity",
    data,
  });
}

// 获取身份认证详情
export function getIdentityPreview(data) {
  return request({
    method: "post",
    path: "user/getIdentityPreview",
    data,
  });
}

// 意见反馈
export function feedback(data) {
  return request({
    method: "post",
    path: "user/feedback",
    data,
  });
}

// 绑定上级
export function bindInviter(data) {
  return request({
    method: "post",
    path: "user/bindInviter",
    data,
  });
}
